import { render } from "./AuAvatar.vue?vue&type=template&id=6573d1c5&scoped=true"
import script from "./AuAvatar.vue?vue&type=script&lang=js"
export * from "./AuAvatar.vue?vue&type=script&lang=js"

import "./AuAvatar.vue?vue&type=style&index=0&id=6573d1c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6573d1c5"]])

export default __exports__